import { createAsyncThunk } from "@reduxjs/toolkit";
import request from "../../../../../../service";
import { IErrorResponse } from "../../../../../../types";
import {
    deletedLearningSettings,
    deletedRestoreLearningSettings,
    setLearningSettings,
    setLearningSettingsRestore,
    updateLearningSettings,
} from "./learningSettingsSlice";
import { ILearningSettingsCreate, ILearningSettingsPayload } from "../types";

const GetLearningSettings = createAsyncThunk("get/learning/settings", async (_, { dispatch, rejectWithValue }) => {
    try {
        const response = await request.get("learning-component-setting");

        dispatch(setLearningSettings(response.data));
        return response.data;
    } catch (error) {
        const typedError = error as IErrorResponse;
        return rejectWithValue(typedError.response.data.message || "Something Wrong");
    }
});

const SetLearningSettings = createAsyncThunk(
    "post/learning/settings",
    async (data: ILearningSettingsCreate, { rejectWithValue }) => {
        try {
            const response = await request.post("learning-component-setting", data);

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;

            return rejectWithValue(typedError.response.data.message || "Something Wrong");
        }
    }
);

const EditLearningSettings = createAsyncThunk(
    "edit/learning/settings",
    async (data: ILearningSettingsPayload, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.put(`/learning-component-setting/${data.id}`, data);
            dispatch(updateLearningSettings(data));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;

            return rejectWithValue(typedError.response.data.message || "Something Wrong");
        }
    }
);

const DeleteLearningSettings = createAsyncThunk(
    "delete/learning/settings",
    async (id: number, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.delete(`/learning-component-setting/${id}`);

            dispatch(deletedLearningSettings(id));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.error);
        }
    }
);

const GetDeleteLearningSettings = createAsyncThunk(
    "get/learning/deleted/settings",
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.get(`/learning-component-setting/deleted-items`);
            dispatch(setLearningSettingsRestore(response.data));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const RestoreDeleteLearningSettings = createAsyncThunk(
    "delete/learning/deleted/settings",
    async (id: number, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.post(`/learning-component-setting/restore/${id}`);
            dispatch(deletedRestoreLearningSettings(id));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

export {
    SetLearningSettings,
    GetLearningSettings,
    EditLearningSettings,
    DeleteLearningSettings,
    RestoreDeleteLearningSettings,
    GetDeleteLearningSettings,
};
